import { render, staticRenderFns } from "./ac-image.vue?vue&type=template&id=ba166312&"
import script from "./ac-image.vue?vue&type=script&lang=js&"
export * from "./ac-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports